export const TITLE = "Infinity Wallet - Plataforma de Cobros";
export const loaderColor = "#012946";
